
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  Ps_LstPerimeters_XRP_Result.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Ps_LstPerimeters_XRP_Result.ts

export class Ps_LstPerimeters_XRP_Result {

  // string SocXRP
  public SocXRP?: string=null;

  // string SocLib
  public SocLib?: string=null;

  // string EtbXRP
  public EtbXRP?: string=null;

  // string EtbLib
  public EtbLib?: string=null;
}